import { Stack, Typography } from '@mui/material';

export function InvalidPermissions() {
  return (
    <Stack
      height="100%"
      width="100%"
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      <Typography color="white" variant="h2" component="div">
        Invalid Permissions
      </Typography>
      <Typography color="white" variant="overline">
        You do not have the proper permissions to view this page. Please Talk to
        your admin for access.
      </Typography>
    </Stack>
  );
}
